import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MinPlayersValidator extends BaseValidator {
    private playersInLineup: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.playersInLineup = sportConfig.getConfigProp('playersInTeam', 0);

        if (this.isPlayersQuantityEnough()) {
            return;
        }

        this.addError(`Please select at least ${this.playersInLineup} players.`);
    }

    private isPlayersQuantityEnough(): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const availablePlayersQuantity = this.calcAvailablePlayersQuantity();

        return availablePlayersQuantity >= this.playersInLineup;
    }

    private calcAvailablePlayersQuantity(): number {
        // @ts-ignore
        const {playersDividedByPosition} = this.dependencies;

        // const lockedPlayersIds = playersLock.getMergedLockedPlayerIds();

        return playersDividedByPosition.length;
    }
}

export {MinPlayersValidator};
